export const SHRED_CHALLENGE_ID = 'oct-2026-shred';
export const SHRED_ROUTE = '/shred';
export const SHRED_LEADERBOARD_ACTION = 'getChallengeLeaderboard';
export const SHRED_DAY_COUNT = 10;
export const SHRED_MIN_SESSIONS = 4;
export const SHRED_BASELINE_DAYS = 45;
export const SHRED_MIN_BASELINE_SESSIONS = 3;
export const SHRED_ROOKIE_BASELINE_SESSIONS = 2;
export const SHRED_MAX_SESSIONS_PER_DAY = 2;
export const SHRED_MAX_SESSION_MINUTES = 31;
export const SHRED_FULL_SESSION_MINUTES = 25;
export const SHRED_ACTIVE_PLAY_MINUTES = 20;
// Mirrors the backend definition: the baseline window is the 45 days ending Oct 19 (Sep 5 to Oct 19).
export const SHRED_BASELINE_WINDOW_LABEL = 'Sep 5 to Oct 19';
export const SHRED_BASELINE_GAP_LABEL = 'Oct 20 and 21';
export const SHRED_GHOST_RANGE_PCT = 30;
export const SHRED_TV_PARAM = 'tv';
export const SHRED_TV_ROTATE_MS = 12000;
export const SHRED_TV_TOP_COUNT = 10;
export const SHRED_TV_VAULT_FIRST_UNLOCK_MS = 700;
export const SHRED_TV_VAULT_UNLOCK_STEP_MS = 1300;
export const SHRED_TV_PRIZE_DROP_FIRST_MIN_MS = 8000;
export const SHRED_TV_PRIZE_DROP_GAP_MIN_MS = 20000;
export const SHRED_TV_PRIZE_DROP_GAP_SPREAD_MS = 14000;
export const SHRED_TV_PRIZE_DROP_SHOW_MS = 5600;
export const SHRED_TV_VAULT_ANIM_MS = 650;
export const SHRED_PRIZE_IDS = { CREW: 'crew', PODIUM: 'podium' };
export const SHRED_POLL_MS = 60000;
export const SHRED_REPLAY_STEP_MS = 1700;
export const SHRED_BOARD_PAGE_SIZE = 20;
export const SHRED_DEMO_PARAM = 'demo';
export const SHRED_DEMO_ME_PARAM = 'me';
export const SHRED_FONTS_HREF =
  'https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700;800&family=DM+Mono:wght@400;500&family=Barlow:wght@400;500;600&display=swap';

export const SHRED_STATUS = {
  UPCOMING: 'upcoming',
  LIVE: 'live',
  ENDED: 'ended',
};

export const SHRED_BRACKETS = {
  REGULAR: 'regular',
  ROOKIE: 'rookie',
};

export const SHRED_AWARD_IDS = {
  SHRED_CHAMPION: 'shredChampion',
  UNDERDOG: 'underdog',
  PACE_KING: 'paceKing',
  IRON_ENGINE: 'ironEngine',
  IRON_HABIT: 'ironHabit',
  ROOKIE_STAR: 'rookieStar',
};

export const SHRED_AWARD_ORDER = [
  SHRED_AWARD_IDS.SHRED_CHAMPION,
  SHRED_AWARD_IDS.UNDERDOG,
  SHRED_AWARD_IDS.PACE_KING,
  SHRED_AWARD_IDS.IRON_ENGINE,
  SHRED_AWARD_IDS.IRON_HABIT,
  SHRED_AWARD_IDS.ROOKIE_STAR,
];

export const SHRED_VALUE_UNITS = {
  PCT: 'pct',
  REPS: 'repsPerSession',
  INDEX: 'index',
  SESSIONS: 'sessions',
};

export const SHRED_AWARD_META = {
  [SHRED_AWARD_IDS.SHRED_CHAMPION]: {
    icon: '🔥',
    title: 'Shred Champion',
    description: 'Biggest improvement against your own baseline.',
    valueUnit: SHRED_VALUE_UNITS.PCT,
    accent: '#ff5a1f',
  },
  [SHRED_AWARD_IDS.UNDERDOG]: {
    icon: '🐺',
    title: 'Underdog',
    description: 'Best improvement among members below the median level.',
    valueUnit: SHRED_VALUE_UNITS.PCT,
    accent: '#34d3c4',
  },
  [SHRED_AWARD_IDS.PACE_KING]: {
    icon: '⚡',
    title: 'Pace King',
    description: 'Most reps per session.',
    valueUnit: SHRED_VALUE_UNITS.REPS,
    accent: '#ffd21f',
  },
  [SHRED_AWARD_IDS.IRON_ENGINE]: {
    icon: '⚙️',
    title: 'Iron Engine',
    description: 'Average work per session relative to your own strength.',
    valueUnit: SHRED_VALUE_UNITS.INDEX,
    accent: '#8fa8ff',
  },
  [SHRED_AWARD_IDS.IRON_HABIT]: {
    icon: '📅',
    title: 'Iron Habit',
    description: 'Most full-length sessions with 20+ minutes of active play.',
    valueUnit: SHRED_VALUE_UNITS.SESSIONS,
    accent: '#ff7ab8',
  },
  [SHRED_AWARD_IDS.ROOKIE_STAR]: {
    icon: '🎃',
    title: 'Rookie Star',
    description: 'Best improvement in the Rookie bracket.',
    valueUnit: SHRED_VALUE_UNITS.PCT,
    accent: '#b57bff',
  },
};

export const SHRED_FEED_TYPES = {
  NEW_LEADER: 'newLeader',
  QUALIFIED: 'qualified',
  CLIMBER: 'climber',
  DAY_RECAP: 'dayRecap',
};

export const SHRED_FEED_ICONS = {
  [SHRED_FEED_TYPES.NEW_LEADER]: '👑',
  [SHRED_FEED_TYPES.QUALIFIED]: '✅',
  [SHRED_FEED_TYPES.CLIMBER]: '🚀',
  [SHRED_FEED_TYPES.DAY_RECAP]: '📣',
};

export const SHRED_ME_REASONS = {
  NO_BASELINE: 'noBaseline',
  NO_SESSIONS: 'noSessions',
  ROOKIE: 'rookie',
};

export const SHRED_CREW_MILESTONES = [25, 50, 75, 100];

export const SHRED_BOARD_FILTERS = {
  ALL: 'all',
  QUALIFIED: 'qualified',
  CHASING: 'chasing',
  ROOKIES: 'rookies',
};

export const SHRED_FALLBACK_AVATAR_BASE = 'https://bbvr-user-profile-pics.s3.amazonaws.com';

export const SHRED_COLORS = {
  ink: '#0c0908',
  charcoal: '#15100d',
  panel: '#1e1613',
  panelRaised: '#291d17',
  line: 'rgba(255, 190, 140, 0.12)',
  text: '#fff3e8',
  muted: '#bba596',
  ember: '#ff5a1f',
  flame: '#ff8a1f',
  gold: '#ffc233',
  red: '#ff3b30',
  positive: '#5be38b',
  negative: '#ff7a70',
  silver: '#cfd6e0',
  bronze: '#d9894a',
  heat: 'linear-gradient(90deg, #ff3b30 0%, #ff5a1f 45%, #ffc233 100%)',
  heatSoft: 'linear-gradient(135deg, rgba(255,90,31,0.28), rgba(255,194,51,0.08))',
};

export const SHRED_FONTS = {
  display: '"Barlow Condensed", "Arial Narrow", sans-serif',
  body: '"Barlow", system-ui, sans-serif',
  numeric: '"DM Mono", ui-monospace, Menlo, monospace',
};

export const SHRED_PODIUM_METALS = [
  { rank: 1, label: 'Gold', color: '#ffc233' },
  { rank: 2, label: 'Silver', color: '#cfd6e0' },
  { rank: 3, label: 'Bronze', color: '#d9894a' },
];

export const SHRED_COPY = {
  PAGE_TITLE: 'Shredoween | Black Box VR',
  PAGE_DESCRIPTION:
    'Oct 22-31: Shredoween, the Black Box VR contest where you race your own baseline. Level and strength give no head start.',
  KICKER: 'BLACK BOX VR · OCT 22–31',
  TITLE_TOP: 'REP OR TREAT',
  TITLE_BOTTOM: 'SHREDOWEEN',
  TAGLINE: 'Race your own ghost. Level 25 or level 100, the only opponent is last month you.',
  COUNTDOWN_UPCOMING: 'Starts in',
  COUNTDOWN_LIVE: 'Ends in',
  COUNTDOWN_ENDED: 'Final results',
  STATUS_UPCOMING: 'OPENS SOON',
  STATUS_LIVE: 'LIVE NOW',
  STATUS_ENDED: 'FINAL',
  STATUS_OFFLINE: 'OFFLINE',
  STATUS_LOADING: 'LOADING',
  LOADING_STANDINGS: 'Loading the standings…',
  SHARE_LABEL: 'Share',
  SHARE_TITLE: 'Shredoween at Black Box VR',
  SHARE_TEXT: 'Join Shredoween: beat your own baseline, not anyone else. Rep or treat, level gives no head start.',
  SHARE_COPIED: 'Link copied',
  SHARE_FAILED: 'Could not share. Copy the address from your browser.',
  LOAD_ERROR: 'Standings are temporarily unavailable. Please try again shortly.',
  RETRY: 'Try again',
  EMPTY_UPCOMING: 'The board lights up when the contest starts. Get your sessions ready.',
  EMPTY_LIVE: 'Nobody has qualified yet. Be the first to log your sessions and take the lead.',
  EMPTY_FILTER: 'No members match that.',
  PODIUM_TITLE: 'The podium',
  PODIUM_EMPTY: 'Spot open',
  FAIRNESS_TITLE: 'Level is not a head start',
  BOARD_TITLE: 'Live board',
  BOARD_SEARCH_LABEL: 'Search members',
  BOARD_SEARCH_PLACEHOLDER: 'Find a member',
  BOARD_ONLY_ME: 'Just me',
  BOARD_SHOW_MORE: 'Show more',
  AWARDS_TITLE: 'Six ways to win',
  AWARDS_HINT: 'Tap a card to see the top three and the reward.',
  AWARD_EMPTY: 'No qualifier yet',
  CREW_TITLE: 'Crew goal',
  FEED_TITLE: 'Play by play',
  FEED_EMPTY: 'Nothing yet. The first moves show up here.',
  REPLAY_TITLE: 'Replay the contest',
  REPLAY_PLAY: 'Play',
  REPLAY_PAUSE: 'Pause',
  REPLAY_LIVE: 'Back to now',
  EXPLAINER_TITLE: 'How scoring works',
  RULES_TITLE: 'Rules',
  ROOKIE_RULES_TITLE: 'Rookie bracket',
  ME_TITLE: 'My progress',
  ME_NO_BASELINE:
    'Complete your first sessions to set a baseline. You will join the Rookie bracket next time.',
  ME_NO_SESSIONS: 'No eligible sessions yet. Get in the headset and put your first work on the board.',
  ME_ROOKIE_TITLE: 'Rookie bracket',
  ME_ROOKIE: (n) =>
    `You are in the Rookie bracket: your first ${n} sessions set your baseline, then every session after counts.`,
  ME_ENDED_NO_ENTRY: 'The contest has ended and no sessions were logged this time. See you at the next one.',
  ME_UPCOMING: 'The contest has not started yet. Your first sessions after the start put you on the board.',
  ME_GHOST_TITLE: 'Race your ghost',
  ROOKIE_TAG: 'Rookie',
  TV_PANELS: { PODIUM: 'podium', BOARD: 'board', RANDOM: 'random', VAULT: 'vault', CREW: 'crew', FEED: 'feed', COUNTDOWN: 'countdown' },
  TV_LINEUP_TITLE: 'Lining up',
  TV_PRIZE_DROP_LABEL: 'Prize drop',
  TV_VAULT_LOCKED_HINT: 'Locked',
  TV_VAULT_TITLE_NOTE: '+ PROFILE TITLE',
  PRIZE_CREW_TITLE: 'Crew Boost',
  PRIZE_PODIUM_TITLE: 'Podium bonus',
  TV_TITLES: { podium: 'The podium', board: 'Top 10', random: 'Who is racing', vault: 'The prize vault', crew: 'Crew goal', feed: 'Play by play', countdown: 'Get ready' },
  ROOKIE_STAR_TITLE: 'Rookie Star',
  BOARD_ROOKIES: 'Rookies',
  REWARD_LABEL: 'TREAT',
  ME_INELIGIBLE_TITLE: 'Not in this one, yet',
  SHELF_TITLE: 'Trophy shelf',
  SHELF_SUBTITLE: 'Shredoween is in the books. Here is who took it home.',
};

export const SHRED_EXPLAINER = [
  {
    icon: '📏',
    title: 'Your own yardstick',
    body: 'We average the work in each of your sessions during the contest and compare it with your average over your prior 45 days.',
  },
  {
    icon: '⚖️',
    title: 'Level-neutral',
    body: 'Score is the percent change, so level and strength give no head start. A level 24 who beats their baseline by 30% outranks a level 98 who beats theirs by 10%.',
  },
  {
    icon: '🎯',
    title: 'Qualify to rank',
    body: 'Log the minimum number of sessions to appear on the ranked board. Until then you are still chasing, and your row shows how close you are.',
  },
];
